import { ISbComponentType, ISbCustomFetch } from 'storyblok-js-client';

import {
  GET_STORIES_EMPTY_RESPONSE,
  STORY_VERSIONS,
} from '@monoimin/constants';

import { getSharedData } from '../api/getSharedData';
import { newStoryblokApi } from './newStoryblokApi';
import { defineMergedParams } from './defineMergedParams';
import { GetStoriesParams, ISbStoriesCustom } from './types';

export interface StoriesCacheOptions {
  revalidate?: number;
}

export const getStories = async <T = ISbComponentType<string>>(
  params?: GetStoriesParams,
  fetchOptions?: ISbCustomFetch,
  isClient?: boolean,
  cacheOptions?: StoriesCacheOptions
) => {
  const mergedParams = await defineMergedParams(params, isClient);

  // Create a stable cache key from the parameters
  const stableParams = Object.entries(params || {})
    .sort(([a], [b]) => a.localeCompare(b))
    .reduce((obj, [k, v]) => ({ ...obj, [k]: v }), {});

  const cacheKey = `stories:${JSON.stringify(stableParams)}`;

  return getSharedData(async () => {
    const { Storyblok } = newStoryblokApi(
      mergedParams.version === STORY_VERSIONS.DRAFT,
      'server',
      cacheOptions?.revalidate
    );

    return Storyblok.getStories(mergedParams, fetchOptions).catch(() => {
      return GET_STORIES_EMPTY_RESPONSE;
    }) as Promise<ISbStoriesCustom<T>>;
  }, cacheKey);
};
